import { Injectable } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';

import { MetadataModule } from './metadata.module';
import { MetadataType, MetaTagNames } from './metadata.type';

@Injectable({
  providedIn: MetadataModule
})
export class MetadataService {

  private defaultMetadata: MetadataType | undefined;

  constructor(
    private title: Title,
    private meta: Meta,
  ) { }

  setDefaultMetadata(metadata: MetadataType) {
    if (typeof metadata === 'object' && metadata !== null) {
      this.defaultMetadata = metadata;
    }
  }

  setMetaTags(metaData?: MetadataType) {
    const tags: MetaDefinition[] = [];
    const mergedMetaData: MetadataType = {
      ...(this.defaultMetadata || {}),
      ...(metaData || {})
    };

    this.resetMetaTags();

    if (mergedMetaData?.title?.trim()) {
      this.title.setTitle(mergedMetaData.title);
      tags.push({ name: MetaTagNames.title, content: mergedMetaData.title });
    }

    if (mergedMetaData?.description?.trim()) {
      tags.push({ name: MetaTagNames.description, content: mergedMetaData.description });
      tags.push({ name: MetaTagNames.ogDescription, content: mergedMetaData.description });
    }

    if (mergedMetaData.image) {
      tags.push({ name: MetaTagNames.image, content: mergedMetaData.image.url });
    }

    if (mergedMetaData?.og_type) {
      tags.push({ name: MetaTagNames.type, content: mergedMetaData.og_type });
    }

    if (mergedMetaData?.twitter_card) {
      tags.push({ name: MetaTagNames.twitterCard, content: mergedMetaData.twitter_card });
    }

    if (mergedMetaData?.twitter_site) {
      tags.push({ name: MetaTagNames.twitterSite, content: mergedMetaData.twitter_site });
    }

    this.meta.addTags(tags);
  }

  private resetMetaTags(): void {
    for (let tag in MetaTagNames) {
      // @ts-ignore
      this.meta.removeTag(`name="${MetaTagNames[tag]}"`);
      // @ts-ignore
      this.meta.removeTag(`property="${MetaTagNames[tag]}"`);
    }
  }
}
